import React, { useState, useEffect, CSSProperties } from 'react'
import { TextField, MenuItem } from '@material-ui/core'

type Props<ValueT> = {
    data: any[]
    dataText: string
    dataValue: string

    defaultValue: ValueT
    propName: string
    label: string
    onChanged: (propName: string, value: ValueT) => void
    style?: CSSProperties
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

const DataBindDropDown = <ValueT,>(props: Props<ValueT>) => {
    const { label, data, dataText, dataValue, defaultValue, propName, onChanged, style, onKeyDown } = props

    const [defaultValueIndex, setDefaultValueIndex] = useState<number | undefined>(undefined)
    const [valueIndex, setValueIndex] = useState<number | undefined>(defaultValueIndex)

    useEffect(() => {
        const dataItem = data.filter(x => x[dataValue] === defaultValue)[0]

        if (!dataItem) {
            if (data.length > 0) {
                setDefaultValueIndex(0)
                console.warn(`Value ${defaultValue} does not exists in data array in key ${dataValue}`)
                return
            } else {
                setDefaultValueIndex(undefined)
                return
            }
        }

        setDefaultValueIndex(data.indexOf(dataItem))

    }, [defaultValue, data, dataValue])

    useEffect(() => {
        setValueIndex(defaultValueIndex)
    }, [defaultValueIndex])

    const handleChange = (valueIndex: number) => {
        setValueIndex(valueIndex)
        const value: ValueT = data[valueIndex][dataValue]
        onChanged(propName, value)
    }

    if (defaultValueIndex === undefined || valueIndex === undefined) {
        return <>
            D: '{defaultValueIndex}'<br />
            V: '{valueIndex}
        </>
    }

    return (
        <TextField
            select
            label={label}
            value={valueIndex}
            onChange={(e) => handleChange(parseInt(e.target.value))}
            style={style}
            onKeyDown={onKeyDown}
        >
            {data.map((d, i) => (
                <MenuItem key={i} value={i}>{d[dataText]}</MenuItem>
            ))}
        </TextField>
    )
}

export default DataBindDropDown